module.exports = __webpack_public_path__ + "static/media/recepbakirci.a90ceba0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/recepbakirci.webp
// module id = 647
// module chunks = 0